<ion-content>
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col class="ion-text-center">
        <ion-icon class="large" name="checkmark-circle" color="success"></ion-icon>

        <h2 class="ion-margin-top">{{ 'PAYMENT.RECEIVED.TITLE' | translate }}</h2>

        <p class="ion-margin-top">
          {{ 'PAYMENT.RECEIVED.DESCRIPTION' | translate }}
        </p>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
